module.exports = __webpack_public_path__ + "static/media/kodiak.d917a9da.png";